export default __webpack_public_path__ + "static/media/banner-mobile.a3796570.png";